import { Box, Grid, Typography } from "@mui/material";

import FormikTimePicker from "@/common/components/fields/formik/formik-time-picker/FormikTimePicker";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { JournalSupportReadOnlyRow } from "@/common/components/journal-support/JournalSupportReadOnlyRow";
import { getTodayAt1530 } from "@/common/components/journal-support/JournalSupportSection.utils";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { useTranslation } from "@/translations";

import { useJournalSupportCreation } from "./hooks/useJournalSupportCreation";

interface Props {
  onClose: () => void;
}

export function JournalSupportCreationDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUserContext();
  const { formik } = useJournalSupportCreation({ onSuccess: onClose });

  const maxTime = getTodayAt1530();

  return (
    <FormDialog
      title={t("calendar.journalSupport.registerTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("calendar.journalSupport.submit")}
    >
      <Typography variant="body2" color="text.secondary" mb={3}>
        {t("calendar.journalSupport.registerDescription")}
      </Typography>

      <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, px: 2, mb: 3 }}>
        <JournalSupportReadOnlyRow label={t("calendar.journalSupport.userCodeLabel")} value={currentUser.userCode} />
        <Box sx={{ borderTop: "1px solid", borderColor: "divider" }} />
        <JournalSupportReadOnlyRow label={t("calendar.journalSupport.nameLabel")} value={currentUser.name} />
      </Box>

      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={6}>
          <FormikTimePicker
            formik={formik}
            fieldName="startTime"
            label={t("calendar.journalSupport.fromLabel")}
            helperText={t("calendar.journalSupport.fromHelper")}
            required
            disabled
          />
        </Grid>
        <Grid size={6}>
          <FormikTimePicker
            formik={formik}
            fieldName="endTime"
            label={t("calendar.journalSupport.toLabel")}
            helperText={t("calendar.journalSupport.toHelperCreate")}
            required
            maxTime={maxTime}
          />
        </Grid>
      </Grid>
    </FormDialog>
  );
}
